/* eslint-disable promise/param-names */
import {
  CATEGORIES_REQUEST,
  CATEGORY_REQUEST_BY_ID,
  CATEGORY_GET_NEW_ID,
  CATEGORY_SAVE,
  CATEGORY_UPDATE,
  CATEGORIES_REPLACE,
  CATEGORIES_SUCCESS
} from '@/store/actions/categories';

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import Vue from 'vue'

import {sleep} from '@/utils/utils.js'

const state = { 
  categories: [],
  status: '', 
  hasLoadedOnce: false,
};

const getters = {
  categories: state => state.categories ? state.categories : [],
  categoriesLoaded: state => { 
    return state.hasLoadedOnce
  }
};

const actions = {
  [CATEGORIES_REQUEST]: ({commit, dispatch}) => {
    if (state.hasLoadedOnce == true) {
      return
    }

    return new Promise((resolve, reject) => {
      commit(CATEGORIES_REQUEST)

      firebase.firestore().collection('categories').orderBy('name')
        .onSnapshot(querySnapshot => {

          let categories = []

          querySnapshot.docChanges().forEach(change => {

            categories.push(change.doc.data())
          })

          if (state.hasLoadedOnce == false) {
            commit(CATEGORIES_SUCCESS, categories)
          } else {
            commit(CATEGORIES_REPLACE, categories)
          }

          resolve();
        })
    })
  },

  [CATEGORY_REQUEST_BY_ID]: ({commit, dispatch}, categoryId) => {
    commit(CATEGORIES_REQUEST)

    return new Promise(async (resolve, reject) => {
      if (!state.hasLoadedOnce) {
        while (state.status === 'loading') {
          await sleep(300)
        }
        let category = state.categories.find(elem => elem.id == categoryId)

        if (category != undefined) {
          resolve(JSON.parse(JSON.stringify(category)))
        } else {
          reject('not found')
        }
      } else {
        let category = state.categories.find(elem => elem.id == categoryId)

        if (category != undefined) {
          resolve(JSON.parse(JSON.stringify(category)))
        }

        reject('not found')
      }
    })
  },

  [CATEGORY_SAVE]: async ({commit}, category) => {
    commit(CATEGORIES_REQUEST);
    return firebase.firestore().collection("categories").doc(String(category.id)).set(category)
          .then(() => {
            return commit(CATEGORIES_SUCCESS);
          })
          .catch(err => console.error(err))
  },
  

  [CATEGORY_UPDATE]: async ({commit}, category) => {
    commit(CATEGORIES_REQUEST)
    return firebase.firestore().collection("categories").doc(String(category.id)).update({
      name: category.name,
      lawyer: category.lawyer
    })
        .then(() => {
          return commit(CATEGORIES_SUCCESS);
        })
        .catch(err => console.error(err))
  },

  [CATEGORY_GET_NEW_ID]: ({commit, dispatch}) => {
    commit(CATEGORIES_REQUEST)

    return new Promise( (resolve, reject) => {
      var getNewCategoryId = firebase.functions().httpsCallable('getNewCategoryId');
      getNewCategoryId().then(result => {
        commit(CATEGORIES_SUCCESS)
        resolve(result.data)
      }).catch(err => {
        reject(err)
      })
    });
  },

}

const mutations = {
  [CATEGORIES_REQUEST]: (state) => {
    state.status = 'loading';
  },

  [CATEGORIES_SUCCESS]: (state, categories) => {
    state.status = 'success';

    if (categories != undefined) {
      state.categories = categories;
      state.hasLoadedOnce = true;
    }
  },

  [CATEGORIES_REPLACE]: (state, categories) => {
    categories.forEach(category => {
      let rowIndex = state.categories.findIndex(elem => elem.id == category.id)
      if (rowIndex != -1) {
        Vue.set(state.categories, rowIndex, category)
      } else {
        state.categories.push(category)
      }
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
